<template>

  <div>
    <!-- Query conditioner -->
    <el-row :gutter="10">
      <el-card shadow="never">
        <el-col :xs="24" :sm="24" :md="6" :lg="6">
          <div class="d-flex justify-space-between">
            <el-input maxlength="240px" clearable
              placeholder="（搜尋儲值帳戶ID或名稱）" v-model="queryParams.keyword"
              @change="onSearchClick">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <!-- <el-button type="primary" circle icon="now-ui-icons ui-1_zoom-bold"
                @click="fetchListOfBillingAccounts" class="ml-4"> 
            </el-button> -->
          </div>
           <br/>
        </el-col>
      </el-card>
    </el-row>
    <br/>
    <el-row :gutter="10">
      <el-col :span="24">
         <data-table ref="table"
          :data="records" :cols="cols" :total="total" :loading="isLoading"
          :on-sort-change="onSortChange" :on-page-request="onPageRequest"
          :rows-per-page-options="[10, 20, 30]" :on-rows-per-page-change="onRowsPerPageChange">

          <div slot="amount" slot-scope="{row}">
            <b v-if="row.pan && row.pan.balance">{{ Number(row.pan.balance.gp + row.pan.balance.pp).toLocaleString()}}</b>
          </div>

          <div slot="status" slot-scope="{row}">
            <span v-if="row.status === 'active'"> 是 </span>
            <span v-else-if="row.status === 'deleted'"> 否 </span>
          </div>

          <div slot="panStatus" slot-scope="{row}">
            <span v-if="row.panStatus === 'pending'"> 尚未啟用 </span>
            <span v-else-if="row.panStatus === 'activated'"> 已啟用 </span>
            <span v-else-if="row.panStatus === 'deactivated'"> 已關閉 </span>
            <span v-else-if="row.panStatus === 'cleared'"> 已清算關閉 </span>
            <span v-else-if="row.panStatus === 'blocked'"> 已暫時凍結 </span>
            <span v-else-if="row.panStatus === 'none'"> 尚未綁定 </span>
            <span v-else> {{row.panStatus}} </span>
          </div>
          <div slot="type" slot-scope="{row}">
            <span v-if="row.type === 'digital'"> 數位帳戶 </span>
            <span v-else-if="row.type === 'physical'"> 實體卡 </span>
          </div>
          <div slot="Actions" slot-scope="{row}">
            <el-button type="primary" icon="el-icon-info" circle size="small" @click="showDetail(row)"></el-button>
          </div>
          
        </data-table>
      </el-col>
    </el-row>
    <!-- Dialog of order detail -->
    <AccountDetail 
      :show.sync="dialog.detail.show" 
      :ba-id="dialog.detail.baId"
      :account="dialog.detail.ba"
      @done="onActionDone">
    </AccountDetail>
    <br/>
  </div>
</template>

<script>
import {
  Button
} from 'element-ui';
import DateRangePicker from 'src/components/DateRangePicker';
import {Modal} from 'src/components';
import DataTable from 'src/components/DataTable';
import AccountFinder from './AccountFinder.vue';
import AccountDetail from './DialogAccountDetail.vue'; 

import { UserInfoMixin } from 'src/mixins/user-info.js';

import axios from 'axios';
import moment from 'moment';

export default {
  components: {
    [Button.name]: Button,
    DateRangePicker,
    Modal,
    DataTable,
    AccountFinder,
    AccountDetail
  },
  mixins: [ UserInfoMixin ],

  mounted() {
    this.fetchListOfBillingAccounts();
  },

  methods: {
    fetchListOfBillingAccounts() {
      const merchantId = 'ddcstore';
      this.isLoading = true;
      // if (keyword !== undefined && !keyword.length) return;
      // let apiHost = 'https://apis-dev.ddc.ai/vas/v1/merchants/ddcstore/management/billing-accounts';
      let apiHost = `${process.env.VUE_APP_APIHOST}/${this.userType}/vas/merchants/ddcstore/billing-accounts`;

      // let apiHost = 'http://localhost:3000/vas/v1/merchants/ddcstore/management/billing-accounts';
      axios.request({
        method: "get",
        url: `${apiHost}`,
        params: {
          startIndex: this.queryParams.startIndex,
          limit: this.queryParams.limit,
          keyword: this.queryParams.keyword
        }
      })
      .then(response => {
        console.log(`[Deposit-Accounts] fetchListOfBillingAccounts`, response.data);

        this.total = response.data.total;
        this.records = response.data.accounts;
        
      })
      .catch(err => {
        console.error(`[Deposit-Accounts] Cannot fetch account list`, err);
        // this.accounts.push({
        //   id: 1,
        //   name: 'test'
        // })
      })
      .finally(() => {
        this.isLoading = false;
      });
    },
    onAccountSelected(accountId, accountName) {
      this.queryParams.accountId = accountId || 0;
      // Reset limit-offset and search inputs.
      this.queryParams.startIndex = 0;
      // this.fetchListOfBillingAccounts();
    },

    onSortChange({prop, key, order}) {
      // console.warn('[ORDERS] DataTable: onSortChange', prop, key, order);
      let ordering = order === 'ascending'? 'asc': 'desc';
      this.queryParams.sort = `${prop}:${ordering}`;
      this.fetchListOfBillingAccounts();
    },
    onPageRequest(page) {
      // console.warn(`[ORDERS] DataTable: Trying to fetch page ${page}...`);
      this.queryParams.startIndex = (page - 1) * this.queryParams.limit;
      this.fetchListOfBillingAccounts();
    },
    onRowsPerPageChange(rpp) {
      this.queryParams.limit = rpp;
      this.queryParams.startIndex = 0;
      this.fetchListOfBillingAccounts();
    },
    onSearchClick() {
      this.queryParams.startIndex = 0;
      this.fetchListOfBillingAccounts();
    },
    showDetail(data) {
      this.dialog.detail.ba = data;
      this.dialog.detail.baId = data.id;
      this.dialog.detail.show = true;
    },
    onActionDone(){
      this.fetchListOfBillingAccounts();
    }
  },

  data() {
    return {
      records: [],
      total: 0,//FIXME: To be updated.
      isLoading: false,

      queryParams: {
        from: moment().startOf('day').toDate(),
        to: new Date(),
        timeBased: 'created_at',

        startIndex: 0,
        limit: 10,
        keyword: undefined,
        accountId: undefined
      },

      cols: [
        {prop: 'billingAccountId', key: 'id', label: '帳戶ID', width: 130, sortable: false},
        {prop: 'billingAccountName', key: 'name', label: '帳戶名稱', sortable: false},
        {prop: 'status', key: 'status', label: '是否可儲值', sortable: false},
        // {prop: 'panId', key: 'panId', label: 'PAN', sortable: false},
        {prop: 'panStatus', key: 'panStatus', label: '帳戶狀態', sortable: false},
        // {prop: 'amount', key: '', label: '儲值金', align:'center', sortable: false},
        // {prop: 'type', key: 'type', label: '類型', sortable: false},
        {prop: 'Actions', key: '', label: '', width: 72}
      ],

      dialog: {
        detail: {
          show: false,
          baId: null,
          ba: undefined,
        }
      },

    };
  },

  computed: {
    user() {
      return this.$store.getters.user;
    },
    userType() {
      return this.$store.getters.userType;
    },

    dateRangePickerEarliest() {
      if (this.userType === 'gaa') return 0;
      return moment().add(-3, 'months').startOf('day').unix();
    },

  },

  filters: {
    toDateTimeString(ts) {
      return ts ? moment.unix(ts).format('YYYY/M/D h:mmA') : '';
    },
  }
};
</script>

<style scoped>
i.el-icon-success {color: green; font-size: 20px;}
i.el-icon-remove {color: red; font-size: 20px;}

.row > .col,
.row > [class*="col-"] {
  padding-left: 5px;
  padding-right: 5px;
}
</style>